import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:25
* @route '/{locale}/tools/pdf/split/page-count'
*/
export const pageCount = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pageCount.url(args, options),
    method: 'post',
})

pageCount.definition = {
    methods: ["post"],
    url: '/{locale}/tools/pdf/split/page-count',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:25
* @route '/{locale}/tools/pdf/split/page-count'
*/
pageCount.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return pageCount.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:25
* @route '/{locale}/tools/pdf/split/page-count'
*/
pageCount.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pageCount.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:25
* @route '/{locale}/tools/pdf/split/page-count'
*/
const pageCountForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pageCount.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:25
* @route '/{locale}/tools/pdf/split/page-count'
*/
pageCountForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pageCount.url(args, options),
    method: 'post',
})

pageCount.form = pageCountForm

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::submit
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:51
* @route '/{locale}/tools/pdf/split'
*/
export const submit = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '/{locale}/tools/pdf/split',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::submit
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:51
* @route '/{locale}/tools/pdf/split'
*/
submit.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return submit.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::submit
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:51
* @route '/{locale}/tools/pdf/split'
*/
submit.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::submit
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:51
* @route '/{locale}/tools/pdf/split'
*/
const submitForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::submit
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:51
* @route '/{locale}/tools/pdf/split'
*/
submitForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

submit.form = submitForm

const split = {
    pageCount: Object.assign(pageCount, pageCount),
    submit: Object.assign(submit, submit),
}

export default split